import React from 'react';
import { Calendar, MapPin, Instagram } from 'lucide-react';
import { Button } from './ui/button';
import { eventsData } from '../data/mock';
import { useNavigate } from 'react-router-dom';

const EventsSection = () => {
  const navigate = useNavigate();

  const handleLearnMore = (eventTitle) => {
    // Navigate to schedules page if it's the Chicago Vegan Farmers Market
    if (eventTitle === "Chicago Vegan Farmers Market") {
      navigate('/schedules');
    }
  };

  return (
    <section className="events-section py-20 md:py-32 relative">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-bold mb-6">
            {eventsData.title}
          </h2>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto opacity-80">
            {eventsData.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {eventsData.events.map((event) => (
            <div key={event.id} className="event-card rounded-3xl overflow-hidden">
              <div className={`event-header ${event.image === 'winter' ? 'winter-theme' : 'summer-theme'}`}>
                <div className="event-season-badge">
                  {event.season}
                </div>
              </div>
              
              <div className="event-content p-8">
                <h3 className="text-3xl font-bold mb-4">
                  {event.title}
                </h3>
                
                <p className="text-lg mb-6 opacity-80">
                  {event.description}
                </p>

                <div className="space-y-3 mb-6">
                  <div className="flex items-center gap-3">
                    <Calendar className="h-5 w-5 event-icon" />
                    <span className="font-semibold">{event.schedule}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <MapPin className="h-5 w-5 event-icon" />
                    <span>{event.frequency}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <Instagram className="h-5 w-5 event-icon" />
                    <a 
                      href={`https://instagram.com/${event.instagram.replace('@', '')}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-medium hover:underline"
                    >
                      {event.instagram}
                    </a>
                  </div>
                </div>

                <Button 
                  className="w-full event-cta"
                  onClick={() => handleLearnMore(event.title)}
                >
                  Learn More
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
